import { createFileRoute, redirect } from "@tanstack/react-router";
import { dashboardCustomersQuery } from "@/api/queries/dashboard";
import { DashboardCustomersPage } from "@/pages/dashboard/CustomersPage";
import { TableSkeleton } from "@/pages/dashboard/table/DataTable";

const sortFields = ["orders", "totalSpent", "lastOrder"] as const;
const directions = ["asc", "desc"] as const;

export const Route = createFileRoute("/dashboard/customers")({
  // Mock data, hidden for real stores until customers are real (docs/plans/marketplace-commerce.md M3, M7).
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
  validateSearch: (search) => ({
    sort: (typeof search.sort === "string" && sortFields.includes(search.sort as (typeof sortFields)[number])
      ? search.sort
      : "totalSpent") as (typeof sortFields)[number],
    dir: (typeof search.dir === "string" && directions.includes(search.dir as (typeof directions)[number])
      ? search.dir
      : "desc") as (typeof directions)[number],
  }),
  loader: ({ context }) => context.queryClient.prefetchQuery(dashboardCustomersQuery()),
  pendingComponent: TableSkeleton,
  component: DashboardCustomersPage,
});
